import React from "react";
import "./Appointments.scss";

import moment from "moment";
import clearStorage from "../DoctorVideo/PatientInfoData";
import VideoIcon from "../../assets/video_call_black_24dp.svg";
import MarkNoShowIcon from "../../assets/Mark-No-Show-Icon.svg";
import UserDetailIcon from "../../assets/person-24px.svg";
import CancelIcon from "../../assets/cancel-px.svg";
import RescheduleIcon from "../../assets/reschedule.svg";
import ViewDocumentIcon from "../../assets/view-documents.svg";
import ViewPrescriptionIcon from "../../assets/view-prescription.svg";
import EditPrescriptionIcon from "../../assets/edit-prescription.svg";
import RaiseInvoiceIcon from "../../assets/raise-invoice-icon.svg";
import callPatientIcon from "../../assets/Call_Patient.svg";
import shareIcon from "../../assets/pem_share_icon.svg";
import Receipt from "../../assets/Receipt.svg";

export default function getAppointmentOptions({
  appointmentData,
  markNoShowAction,
  rescheduleAppointmentAction,
  raiseInvoiceAction,
  handleViewDocumentClick,
  setAnchorEl,
  showVideoIcon,
  handleJoinCallClick,
  viewAppointment,
  cancelAppointmentAction,
  startTimer,
  editPrescriptionAction,
  setShowCallPatientModal,
  timerHours,
  timerMinutes,
  timerSeconds,
  shareReceipt,
  viewReceipt,
  sharePEMClick,
}) {
  const options = {
    icon: `${UserDetailIcon}`,
    label: "View Details",
    clickHandler: () => {
      viewAppointment(appointmentData.appointment_id);
      setAnchorEl(null);
    },
  };
  const inClinic = [
    options,
    {
      icon: `${RaiseInvoiceIcon}`,
      label: "Mark Check In",
      clickHandler: () => {
        raiseInvoiceAction(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      icon: `${MarkNoShowIcon}`,
      label: "Mark No Show",
      clickHandler: () => {
        markNoShowAction(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      icon: `${CancelIcon}`,
      label: "Cancel",
      clickHandler: () => {
        cancelAppointmentAction(appointmentData);
        setAnchorEl(null);
      },
    },
  ];

  if (
    appointmentData?.has_document === "True" &&
    appointmentData?.appointment_status != "No show"
  ) {
    return [
      options,
      {
        icon: `${ViewDocumentIcon}`,
        label: "View Documents",
        clickHandler: () => {
          handleViewDocumentClick(appointmentData);
          setAnchorEl(null);
        },
      },
    ];
  } else if (
    appointmentData?.appointment_status != "No show" &&
    appointmentData?.appointment_status === "completed"
    //  &&
    // appointmentData.prescription_notification_sent === "False"
  ) {
    let option = [
      {
        icon: `${shareIcon}`,
        label: "Patient Education",
        clickHandler: () => {
          sharePEMClick(appointmentData.patient_id);
          setAnchorEl(null);
        },
      },
      {
        icon: `${Receipt}`,
        label: "View Receipt",
        clickHandler: () => {
          viewReceipt();
          setAnchorEl(null);
        },
      },
      {
        icon: `${Receipt}`,
        label: "Share Receipt",
        clickHandler: () => {
          shareReceipt();
          setAnchorEl(null);
        },
      },
    ];
    const endTime = moment(
      appointmentData?.appointment_end_date_time.split("+")[0]
    ).add(48, "hours");
    const editButtonStatus = moment().isAfter(endTime); // true
    let is_allow = localStorage.getItem("edit_prescriptions_allow");
    if (
      editButtonStatus ||
      (timerHours === 0 && timerMinutes === 0 && timerSeconds === 0)
    ) {
      if (
        appointmentData.prescription_notification_sent === "True" ||
        appointmentData.manual_rx_notification_sent === "True"
      ) {
        return [
          options,
          {
            icon: `${ViewPrescriptionIcon}`,
            label: "View Prescription",
            clickHandler: () => {
              setAnchorEl(null);
            },
          },
          ...option,
        ];
      } else {
        return [options, ...option];
      }
    } else if (!editButtonStatus || is_allow) {
      startTimer(
        appointmentData.consultation_end_time
          ? appointmentData.consultation_end_time
          : appointmentData.appointment_date +
              " " +
              appointmentData.appointment_end_time.split("+")[0]
      );
      clearStorage.clearPatientData();
      if (localStorage.getItem("user_type") === "doctor") {
        return [
          options,
          {
            icon: `${shareIcon}`,
            label: "Patient Education",
            clickHandler: () => {
              sharePEMClick(appointmentData.patient_id);
              setAnchorEl(null);
            },
          },
          {
            icon: `${EditPrescriptionIcon}`,
            label: "Edit Prescription",
            clickHandler: () => {
              editPrescriptionAction(appointmentData);
              setAnchorEl(null);
            },
          },
          {
            icon: `${callPatientIcon}`,
            label: "Call Patient",
            clickHandler: () => {
              setShowCallPatientModal(true);
              setAnchorEl(null);
            },
          },
          option,
        ];
      }
    }
    // else{
    //   if (appointmentData.prescription_notification_sent === "True" || appointmentData.manual_rx_notification_sent==="True"){
    //     return [
    //       options,
    //       {
    //         icon: `${ViewPrescriptionIcon}`,
    //         label: "View Prescription",
    //         clickHandler: () => {
    //           setAnchorEl(null);
    //         },
    //       },
    //     ];
    //   }
    //   else{
    //     return [options];
    //   }
    // }
  }
  // else if (
  //   appointmentData?.appointment_status != "No show" &&
  //   appointmentData?.appointment_status === "completed" &&
  //   appointmentData.prescription_notification_sent === "True"
  // ) {
  //   return [
  //     options,
  //     {
  //       icon: `${ViewPrescriptionIcon}`,
  //       label: "View Prescription",
  //       clickHandler: () => {
  //         setAnchorEl(null);
  //       },
  //     },
  //   ];
  //   // prescription
  // }
  else if (
    showVideoIcon &&
    appointmentData?.appointment_status != "No show" &&
    appointmentData?.appointment_status !== "completed" &&
    !appointmentData?.appointment_status?.toLowerCase().includes("cancelled") &&
    appointmentData.appointment_type === "online"
  ) {
    return [
      options,
      {
        icon: `${VideoIcon}`,
        label: "Make Call",
        clickHandler: () => {
          handleJoinCallClick(appointmentData);
          setAnchorEl(null);
        },
      },
      {
        icon: `${callPatientIcon}`,
        label: "Call Patient",
        clickHandler: () => {
          setShowCallPatientModal(true);
          setAnchorEl(null);
        },
      },
    ];
    //   video call
  } else if (
    appointmentData?.appointment_status != "No show" &&
    appointmentData?.appointment_status !== "completed" &&
    !appointmentData?.appointment_status?.toLowerCase().includes("cancelled") &&
    appointmentData.appointment_type === "in-clinic"
  ) {
    return inClinic;
  } else if (
    appointmentData?.appointment_status != "No show" &&
    !appointmentData?.appointment_status?.includes("reschedule") &&
    appointmentData?.appointment_status === "upcoming"
  ) {
    return [
      options,
      {
        icon: `${RescheduleIcon}`,
        label: "Reschedule",
        clickHandler: () => {
          rescheduleAppointmentAction(appointmentData);
          setAnchorEl(null);
        },
      },
      {
        icon: `${CancelIcon}`,
        label: "Cancel",
        clickHandler: () => {
          cancelAppointmentAction(appointmentData);
          setAnchorEl(null);
        },
      },
    ];
  } else {
    return [options];
  }
}
